import { theme } from 'style/globalStyle';
import { makeStyles } from 'tss-react/mui';

export const sizeStyles = {
  small: { width: '150px' },
  medium: { width: '250px' },
  large: {},
};

export const titleColors = {
  default: { color: '#000', backgroundColor: '#FFF' },
  warning: {
    color: '#FFF',
    backgroundColor: theme.palette.warning.warning600,
  },
};

export const sizePadding = {
  small: { padding: '4px' },
  medium: { padding: '8px' },
  large: { padding: '16px' },
};

export const crossStyles = (popperSize) => {
  let style = {};
  switch (popperSize) {
    case 'medium':
      style.width = '15px';
      break;
    case 'large':
      style.width = '17px';
      break;
    case 'small':
    default:
      style.width = '12px';
      break;
  }
  return style;
};

const useStyles = makeStyles()((theme) => ({
  popperRoot: {
    borderRadius: '8px',
    backgroundColor: '#FFF',
    boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.07)',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  },
  title: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '120%',
    letterSpacing: '-0.12px',
  },
  cross: {
    cursor: 'pointer',
  },
}));

export default useStyles;
